import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnZW: CultureInfo = {
  name: 'en-ZW',
  displayName: 'English (Zimbabwe)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-ZW',
  parent: CultureInfoEn
};
